import { createFileRoute, Outlet } from '@tanstack/react-router'
import PlanViewerNew from '../../../../../../containers/plan-viewer'
import { pinsSearchSchema } from './search-schemas'

// Layout boundary for the legacy plan-root viewer
// `/project/:projectId/:planId/:viewType/**` (no `/pins/`) — Card 3.13.
//
// `_viewer` is a pathless group (adds no URL segment), so the live URL stays
// exactly the shape every caller already builds: `/project/{projectId}/
// {planId}/{viewType}/...`. It mounts <PlanViewerNew /> once (the container was
// taken off react-router in Card 3.11) and lets the leaf routes drive path
// identity (viewType / pinId) via useParams({ strict: false }). The shared 3.8
// schema is applied here so every leaf inherits the validated search state.
//
// NB: `$planId` is a dynamic sibling of the static subdomains (`pins`, `team`,
// `tasks`, `datasets`, `media`, `groups`, `reports`) and of the `_plans/`-hosted
// static routes (`rename`, `settings`, `import`, ...). TanStack ranks static >
// dynamic, so those keywords keep winning and only a real planId falls through
// here — mirroring the legacy router, which listed plan-root after every named
// route.
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/$planId/_viewer'
)({
  validateSearch: pinsSearchSchema,
  component: PlanRootViewerLayout
})

function PlanRootViewerLayout() {
  return (
    <>
      <PlanViewerNew />
      <Outlet />
    </>
  )
}
